import { useState } from 'react';
import './Missao.css';
import { missaoCards, CARDS_PER_PAGE } from '../../constants';

function Missao() {
  const [currentPage, setCurrentPage] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const cardsPerPage = CARDS_PER_PAGE;
  const totalPages = Math.ceil(missaoCards.length / cardsPerPage);

  const nextPage = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentPage((prev) => (prev + 1) % totalPages);
      setIsTransitioning(false);
    }, 300);
  };

  const prevPage = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
      setIsTransitioning(false);
    }, 300);
  };

  const startIndex = currentPage * cardsPerPage;
  const currentCards = missaoCards.slice(startIndex, startIndex + cardsPerPage);

  return (
    <section id="missao" className="missao-section">
      <div className="missao-container">
        <div className="missao-statement">
          <h2>Missão</h2>
          <p>Oferecer saúde e qualidade de vida, impactando gerações através da medicina funcional integrativa.</p>
        </div>

        <div className="visao-statement">
          <h2>Visão</h2>
          <p>Tornar-se uma referência regional em medicina funcional integrativa, reconhecida pela excelência no cuidado preventivo e personalizado, estabelecendo relações de longo prazo com os pacientes e promovendo uma cultura de saúde e autocuidado.</p>
        </div>

        <h2 className="valores-title">Valores</h2>
        <div className={`missao-cards-grid ${isTransitioning ? 'fade-out' : 'fade-in'}`}>
          {currentCards.map((card, index) => (
            <div key={startIndex + index} className="card">
              <h1>{card.titulo}</h1>
              <p className="card-description">{card.descricao}</p>
            </div>
          ))}
        </div>
        <div className="missao-pagination">
          <button className="missao-nav-text" onClick={prevPage}>
            Anterior
          </button>
          <span className="page-number">{currentPage + 1}</span>
          <button className="missao-nav-text" onClick={nextPage}>
            Próximo
          </button>
        </div>
      </div>
    </section>
  );
}

export default Missao;
